module.exports = __webpack_public_path__ + "static/media/pricing_footer.aaa56ac8.png";